import type { ActiveJobInfo } from '@runhuman/shared';
import { openTestHarness } from './harness';
import { ExternalLinkIcon } from '../../ExternalLinkIcon';

interface Props {
  readonly activeJob: ActiveJobInfo;
}

/**
 * In-flight-job card. Shown at the top of the tester view when the
 * authenticated user has a claimed job that hasn't been completed yet.
 *
 * The card collapses the queue below it visually (the App.tsx parent decides
 * layout); the prominent CTA is "Resume testing" → opens the web testing
 * harness in a fresh browser window for that specific jobId.
 */
export function ActiveJobPanel({ activeJob }: Props) {
  return (
    <section className="active-job">
      <h2>In progress</h2>
      <div className="active-job__card">
        <div className="active-job__url">{activeJob.url}</div>
        <button
          type="button"
          className="active-job__resume"
          onClick={() => openTestHarness({ jobId: activeJob.id, testerToken: activeJob.testerToken })}
        >
          Resume testing
          <ExternalLinkIcon />
        </button>
      </div>
    </section>
  );
}
